import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { applyBrandedPdfChrome, exportNodeAsBrandedPNG } from '../../branding/exportBranding';

export async function exportChartAsPNG(chartRef, fileName) {
  if (!chartRef.current) {
    console.warn('Chart reference is not set');
    return;
  }

  try {
    await exportNodeAsBrandedPNG(chartRef.current, fileName);
  } catch (error) {
    console.error('Failed to export chart as PNG:', error);
  }
}

export function exportStepTableAsCSV(selectedData) {
  if (!selectedData) return;

  if (Array.isArray(selectedData.rows) && Array.isArray(selectedData.columns)) {
    const csvRows = [
      selectedData.columns.map((column) => column.label),
      ...selectedData.rows.map((row) => selectedData.columns.map((column) => {
        const value = typeof column.format === 'function'
          ? column.format(row[column.key])
          : row[column.key] ?? '';
        return String(value).replaceAll('"', '""');
      })),
    ];
    const csvContent = csvRows
      .map((row) => row.map((cell) => `"${cell}"`).join(','))
      .join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'control_chart_data.csv');
    return;
  }

  const csvRows = [
    ['Serial Number', 'Observation', 'Value'],
    ...selectedData.values.map((value, index) => [
      selectedData.serialNumbers ? selectedData.serialNumbers[index] : 'N/A',
      index + 1,
      value,
    ]),
  ];
  const csvContent = csvRows.map((row) => row.join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, 'control_chart_data.csv');
}

export function exportStepTableAsPDF(selectedData) {
  if (!selectedData) return;

  const doc = new jsPDF();

  if (Array.isArray(selectedData.rows) && Array.isArray(selectedData.columns)) {
    doc.text(selectedData.title || 'Control Chart Details', 14, 15);
    doc.autoTable({
      head: [selectedData.columns.map((column) => column.label)],
      body: selectedData.rows.map((row) => (
        selectedData.columns.map((column) => (
          typeof column.format === 'function'
            ? column.format(row[column.key])
            : row[column.key] ?? ''
        ))
      )),
      startY: 20,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [52, 95, 124] },
    });
    applyBrandedPdfChrome(doc, { title: selectedData.title || 'Control Chart Details' });
    doc.save('control_chart_data.pdf');
    return;
  }

  const tableColumn = ['Serial Number', 'Observation', 'Value'];
  const tableRows = selectedData.values.map((value, index) => [
    selectedData.serialNumbers ? selectedData.serialNumbers[index] : 'N/A',
    index + 1,
    value,
  ]);

  doc.text(`Extracted Values for Step ${selectedData.stepNumber}`, 14, 15);
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 20,
  });
  applyBrandedPdfChrome(doc, { title: `Extracted Values for Step ${selectedData.stepNumber}` });
  doc.save('control_chart_data.pdf');
}
